<template>
    <div ref="chart" style="width: 100%; height: 750px;"
        class="bg-white border border-indigo-200 dark:border-ternary-dark rounded-xl">
    </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    name: 'MapChart',
    data() {
        return {
            chart: null,
            mapData: [], // Tambahkan properti untuk menyimpan data peta
        };
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                const response = await fetch('https://script.google.com/macros/s/AKfycbyFZniFkps8UpT9IIJ1WwQIkrfWMLMi8_PZjnRArcUlIAaO0_xaAQf41opbuxXDlFv9uw/exec');
                const data = await response.json();
                this.mapData = data; // Simpan data yang diterima

                // Load GeoJSON data untuk peta
                const geoJson = await import('@/components/maps/world.json');
                echarts.registerMap('world', geoJson);

                this.chart = echarts.init(this.$refs.chart);
                this.chart.setOption({
                    title: {
                        text: 'Peta Persebaran Asal Negara Lagu #WhatSongOnielPlay',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c}',
                    },
                    visualMap: {
                        min: 0,
                        max: this.calculateMaxFrequency(), // Hitung nilai maksimum secara dinamis
                        text: ['Tinggi', 'Rendah'],
                        realtime: false,
                        calculable: true,
                        inRange: {
                            color: ['lightskyblue', 'yellow', 'orangered'],
                        },
                    },
                    series: [
                        {
                            name: 'Peta Persebaran Asal Negara Lagu #WhatSongOnielPlay',
                            type: 'map',
                            map: 'world',
                            roam: true,
                            emphasis: {
                                label: {
                                    show: true,
                                },
                            },
                            data: this.mapData, // Gunakan data yang diambil dari App Script
                        },
                    ],
                });
            } catch (error) {
                console.error('Gagal mengambil data dari Google App Script:', error);
            }
        },
        calculateMaxFrequency() {
            if (this.mapData && this.mapData.length > 0) {
                return Math.max(...this.mapData.map(item => item.value));
            }
            return 1000; // Nilai default jika data belum tersedia
        },
    },
    beforeUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    },
};
</script>

<style scoped>
/* Tambahkan style jika diperlukan */
</style>